"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlacesAutoComplete = exports.getPlaceFirstName = exports.getPlaceById = exports.getPlaceAutoCompleteType = exports.getAddressByQuery = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requestService = require("./requestService");

var getPlacesAutoComplete = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(query) {
    var allowFullAddress,
        placesAutoComplete,
        res,
        _args = arguments;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            allowFullAddress = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;

            if (!(typeof query !== "string")) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            placesAutoComplete = [];
            _context.prev = 4;
            _context.next = 7;
            return (0, _requestService.getRequest)("/vendors/get-places-autocomplete?q=".concat(query).concat(allowFullAddress ? "&full_address=true" : ""));

          case 7:
            res = _context.sent;

            if (res !== null && res !== void 0 && res.data) {
              placesAutoComplete = res.data;
            }

            _context.next = 13;
            break;

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);

          case 13:
            return _context.abrupt("return", placesAutoComplete);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 11]]);
  }));

  return function getPlacesAutoComplete(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.getPlacesAutoComplete = getPlacesAutoComplete;

var getPlaceById = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(placeId) {
    var selectedPlace, res;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return (0, _requestService.getRequest)("/vendors/get-place-by-id?placeId=".concat(placeId));

          case 3:
            res = _context2.sent;

            if (res !== null && res !== void 0 && res.data) {
              selectedPlace = res.data;
            }

            _context2.next = 9;
            break;

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);

          case 9:
            return _context2.abrupt("return", selectedPlace);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function getPlaceById(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.getPlaceById = getPlaceById;

var getPlaceFirstName = function getPlaceFirstName(selectedPlace) {
  if (!(selectedPlace !== null && selectedPlace !== void 0 && selectedPlace.data)) return "";
  var _selectedPlace$data = selectedPlace.data,
      sublocality = _selectedPlace$data.sublocality,
      locality = _selectedPlace$data.locality,
      administrativeAreaLevel2 = _selectedPlace$data.administrativeAreaLevel2,
      administrativeAreaLevel1 = _selectedPlace$data.administrativeAreaLevel1;
  return sublocality || locality || administrativeAreaLevel2 || administrativeAreaLevel1;
};

exports.getPlaceFirstName = getPlaceFirstName;

var getPlaceAutoCompleteType = function getPlaceAutoCompleteType(autoCompleteResult) {
  if (!(autoCompleteResult !== null && autoCompleteResult !== void 0 && autoCompleteResult.types) || (autoCompleteResult === null || autoCompleteResult === void 0 ? void 0 : autoCompleteResult.types.length) === 0) return "";
  var type = autoCompleteResult.types[0];
  var result = "";

  switch (type) {
    case "route":
      result = "Street";
      break;

    case "sublocality_level_1":
    case "sublocality":
    case "neighborhood":
      result = "Neighborhood";
      break;

    case "locality":
      result = "City";
      break;

    case "administrative_area_level_1":
      result = "State";
      break;

    case "administrative_area_level_2":
      result = "County";
      break;

    case "postal_code":
      result = "Zipcode";
      break;

    default:
      break;
  }

  return result;
};
/**
 * Search for a property by address query, use both places auto complete and getPlaceById provided by Google
 * @param {String} searchQuery
 */


exports.getPlaceAutoCompleteType = getPlaceAutoCompleteType;

var getAddressByQuery = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(searchQuery) {
    var addressObj, placesAutoComplete;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return getPlacesAutoComplete(searchQuery, true);

          case 3:
            placesAutoComplete = _context3.sent;

            if (!placesAutoComplete.length) {
              _context3.next = 8;
              break;
            }

            _context3.next = 7;
            return getPlaceById(placesAutoComplete[0].place_id);

          case 7:
            addressObj = _context3.sent;

          case 8:
            _context3.next = 12;
            break;

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](0);

          case 12:
            return _context3.abrupt("return", addressObj);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 10]]);
  }));

  return function getAddressByQuery(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.getAddressByQuery = getAddressByQuery;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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